import { render, staticRenderFns } from "./SiniestroPdf.vue?vue&type=template&id=38426f50&"
import script from "./SiniestroPdf.vue?vue&type=script&lang=js&"
export * from "./SiniestroPdf.vue?vue&type=script&lang=js&"
import style0 from "./SiniestroPdf.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports